// src/store/apis/mobCreditAPI.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const mobCreditAPI = createApi({
  reducerPath: "mobCreditAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // GET /api/mob-credit/check-phone/?phone=XXXXXXXXXX
    checkPhoneFlags: builder.query({
      query: (phone) => ({
        url: "api/mob-credit/check-phone/",
        params: { phone },
      }),
      transformResponse: (resp) =>
        resp?.status && resp?.data
          ? {
              lineOfCreditEnabled: !!resp.data.lineOfCreditEnabled,
              mobCreditEnabled: !!resp.data.mobCreditEnabled,
            }
          : null,
    }),

    
    createMobCredit: builder.mutation({
      query: (formData) => ({
        url: "accounts/mob-line-of-credit/",
        method: "POST",
        body: formData,
      }),
    }),

    
    getApprovalDetails: builder.query({
      query: (id) => ({
        url: `api/mob-credit/approval-details/`,
        params: { id },
      }),
      transformResponse: (resp) => resp?.data || null,
    }),

    
    checkAccountAllowed: builder.query({
      query: (phone) => ({
        url: "api/mob-credit/account-allowed/",
        params: { phone },
      }),
      transformResponse: (resp) => resp?.allowed ?? null,
    }),
  }),
});

export const {
  useCheckPhoneFlagsQuery,        
  useLazyCheckPhoneFlagsQuery,

} = mobCreditAPI;

export default mobCreditAPI;
